import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import clsx from "clsx";
import s from "../GR.less";
import rowStyles from "./rowStyles.less";

export const getGRColumns = (
  t: TFunction,
  options: string[],
  optionChildren: string[],
  styleRow: boolean
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`globalRating.${option}`),
      dataIndex: option,
      key: option,
      align: (option !== "name" ? "center" : "left") as "left" | "center",
      onCell: (record: any) => {
        const classes = clsx({
          [rowStyles.style_back]: styleRow === true && !record.ParentId,
          [rowStyles.style_last_row]: record.typeName === "total",
          [rowStyles.deleted_gr]:
            option !== "number" && record[option] === undefined,

          // Красный фон для отрицательных значений между кварталами
          [rowStyles.red]:
            option === "IndicatorQuarter1_2"
              ? record.IndicatorQuarter1_2 < 0
              : option === "IndicatorQuarter2_3"
              ? record.IndicatorQuarter2_3 < 0
              : option === "IndicatorQuarter3_4"
              ? record.IndicatorQuarter3_4 < 0
              : false,

          // Зеленый фон для положительных значений между кварталами
          [rowStyles.green]:
            option === "IndicatorQuarter1_2"
              ? record.IndicatorQuarter1_2 > 0
              : option === "IndicatorQuarter2_3"
              ? record.IndicatorQuarter2_3 > 0
              : option === "IndicatorQuarter3_4"
              ? record.IndicatorQuarter3_4 > 0
              : false,

          // Красный текст для строк без номера (заголовки) с отрицательными значениями
          [rowStyles.loft]:
            styleRow && (record.number === "" || record.number === null)
              ? option === "IndicatorQuarter1_2"
                ? record.IndicatorQuarter1_2 < 0
                : option === "IndicatorQuarter2_3"
                ? record.IndicatorQuarter2_3 < 0
                : option === "IndicatorQuarter3_4"
                ? record.IndicatorQuarter3_4 < 0
                : false
              : false,

          // Зеленый текст для строк без номера (заголовки) с положительными значениями
          [rowStyles.loft_green]:
            styleRow && (record.number === "" || record.number === null)
              ? option === "IndicatorQuarter1_2"
                ? record.IndicatorQuarter1_2 > 0
                : option === "IndicatorQuarter2_3"
                ? record.IndicatorQuarter2_3 > 0
                : option === "IndicatorQuarter3_4"
                ? record.IndicatorQuarter3_4 > 0
                : false
              : false,
        });

        return {
          className: classes,
        };
      },
    };

    // Для колонок name и number показываем NoActual версии
    if (optionChildren.includes(option)) {
      return {
        ...baseColumn,
        render: (value: any, record: any) => (
          <div>
            {record[option + "NoActual"] && (
              <div className={rowStyles.NoActual}>
                {record[option + "NoActual"]}
              </div>
            )}
            {option === "name" && (
              <span className={rowStyles.lastName}>{value}</span>
            )}
            {option !== "name" && value}
          </div>
        ),
      };
    }

    // Для колонки name добавляем жирный шрифт для последнего значения
    if (option === "name") {
      return {
        ...baseColumn,
        render: (value: any) => (
          <span className={rowStyles.lastName}>{value}</span>
        ),
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
